var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcoKtas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 1V7C13 7.82966 13.6704 8.49995 14.5 8.5H20.5V20C20.5 21.6547 19.1547 23 17.5 23H6.5C4.84535 23 3.5 21.6547 3.5 20V17H8.28613L9.58008 19.5879C9.70665 19.8409 9.96883 20 10.25 20C10.5312 20 10.7933 19.8409 10.9199 19.5879L13.25 15.9287L14.0801 17.5879C14.2066 17.8409 14.4641 18 14.75 18H17.5C17.9125 18 18.25 17.6625 18.25 17.25C18.2498 16.8377 17.9124 16.5 17.5 16.5H15.2139L13.9199 13.9131C13.7934 13.66 13.5312 13.5 13.25 13.5C12.9688 13.5 12.7066 13.66 12.5801 13.9131L10.25 17.5723L9.41992 15.9131C9.29335 15.66 9.03592 15.5 8.75 15.5H3.5V4C3.50022 2.34552 4.84549 1.00005 6.5 1H13ZM5.59082 4.60059V11.6006H7.04102V9.59863L7.77637 8.70996L9.71973 11.6006H11.46L8.82031 7.7334L11.4307 4.60059H9.68066L7.1377 7.7041H7.04102V4.60059H5.59082ZM20.5 7H14.5V1L20.5 7Z",
    fill: "#00858A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcoKtas);
export default __webpack_public_path__ + "static/media/Home_ico_ktas.24390ff0aa35506de1358d720a7ecf91.svg";
export { ForwardRef as ReactComponent };